import React from 'react';
import {Card, CardContent, Grid, Typography } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import Card64Image from 'components/card64Image';

const DetalleDeLaPantalla = ({datosDelMedioSeleccionado}) => {
  const classes = styles();

  const {departamento, municipio, ancho, alto, coordenadas, sentidoDeVisualizacion, descripcionUbicacion, medioDeComunicacion} = datosDelMedioSeleccionado;

  return (
    <Card className={classes.root}>
        <CardContent>
          <Grid container justify="space-between" alignItems="center" spacing={4} wrap={"wrap"} >
              <Grid item xs={12}>
                <TituloConIcono title={"Datos de la pantalla digital"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
              </Grid>
              <Grid item xs={12} md={6}>
                <ElementoDelCard title={'Nombre:'} label={medioDeComunicacion?.nombre || ""}/>
                <ElementoDelCard title={'Departamento:'} label={departamento?.nombre || ""}/>
                <ElementoDelCard title={'Municipio:'} label={municipio?.nombre || ""}/>
                <ElementoDelCard title={'Ancho:'} label={ancho || ""}/>
                <ElementoDelCard title={'Alto:'} label={ alto || ""}/>
                <ElementoDelCard title={'Coordenadas:'} label={coordenadas || ""}/>
                <ElementoDelCard title={'Sentido de visualización:'} label={sentidoDeVisualizacion?.descripcion || ""}/>
                <ElementoDelCard title={'ubicación de la pantalla:'} label={descripcionUbicacion || ""}/>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid item xs={12}>
                  <Grid item xs={12} md={6}>
                    {medioDeComunicacion?.qr ? (
                        <Card64Image
                            label={"QR"} image={medioDeComunicacion?.qr} title={"QR"} src={medioDeComunicacion?.qr} showTitle={false} showTitle2={true} documentName={medioDeComunicacion?.nombre} getDocumentOfPoliticalOrganization={undefined} showButtonEditDocument={false} handleClickUpdateDocument={undefined}
                            showInMovil={true} firstTitle={""} observacion={""} idDocumento={"idDocumento"} idEstadoDocumento={""}
                        />
                    ): <Typography variant="h5" component="div" align='center'> No hay QR</Typography>}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    {medioDeComunicacion?.logo ? (
                          <Card64Image
                              label={"LOGO"} image={medioDeComunicacion?.logo} title={"LOGO"} src={medioDeComunicacion?.logo} showTitle={false} showTitle2={true} documentName={medioDeComunicacion?.nombre} getDocumentOfPoliticalOrganization={undefined} showButtonEditDocument={false} handleClickUpdateDocument={undefined}
                              showInMovil={true} firstTitle={""} observacion={""} idDocumento={"idDocumento"} idEstadoDocumento={""}
                          />
                    ): <Typography variant="h5" component="div" align='center'> No Adjunto imagen de la pantalla digital</Typography>}
                  </Grid>
                  </Grid>
              </Grid>
          </Grid>
        </CardContent>
    </Card>
  );
}

export default DetalleDeLaPantalla;